import { EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CameleonService } from '~/app/shared/cameleon/cameleon.service';
var SimpleSelectComponent = /** @class */ (function () {
    /**
       * Constructor
       */
    function SimpleSelectComponent(cameleonService) {
        this.cameleonService = cameleonService;
        this._json = {
            "parameters": [
                {
                    "@name": "valuations",
                    "list": [
                        {
                            "pair": {
                                "left": {
                                    "cpe": ""
                                },
                                "right": {
                                    "SingleValuation": {
                                        "@isCommentUserChoice": "false",
                                        "@isQtyUserChoice": "false",
                                        "@isValueUserChoice": "true",
                                        "Value": {
                                            "@userQty": null,
                                            "pkValue": ""
                                        },
                                        "Comment": null
                                    }
                                }
                            }
                        }
                    ]
                }
            ]
        };
        this._value = '';
        this.onChange = new EventEmitter();
    }
    Object.defineProperty(SimpleSelectComponent.prototype, "fp", {
        get: function () { return this._fp; },
        set: function (data) {
            this._fp = data;
            this._json.parameters[0].list[0].pair.left.cpe = this.fp.id;
            this._value = this.fp.value;
            this._json.parameters[0].list[0].pair.right.SingleValuation.Value.pkValue = this._value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SimpleSelectComponent.prototype, "value", {
        get: function () { return this._value; },
        set: function (data) {
            this._value = data;
            this._json.parameters[0].list[0].pair.right.SingleValuation.Value.pkValue = data;
            this.onChange.emit(this._json);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * On init
     */
    SimpleSelectComponent.prototype.ngOnInit = function () {
    };
    /**
    * On destroy
    */
    SimpleSelectComponent.prototype.ngOnDestroy = function () {
    };
    return SimpleSelectComponent;
}());
export { SimpleSelectComponent };
